module.exports = __webpack_public_path__ + "@/assets/img/phishing.e87f16b9.svg";